import React from 'react';
import styles from './UsagePercentBar.module.scss';

const clampPercent = (percent) => Math.min(100, Math.max(0, Number(percent) || 0));

const getStage = (percent) => {
  if (percent >= 100) return 'critical';
  if (percent >= 80) return 'warning';
  return 'default';
};

const UsagePercentBar = ({ percent }) => {
  const boundedPercent = clampPercent(percent);
  const stage = getStage(boundedPercent);

  return (
    <div
      className={styles.track}
      role="progressbar"
      aria-valuemin="0"
      aria-valuemax="100"
      aria-valuenow={boundedPercent}
    >
      <div
        className={`${styles.fill} ${styles[stage]}`}
        style={{ width: `${boundedPercent}%` }}
      />
    </div>
  );
};

export default UsagePercentBar;
